
import Vue from 'vue'
// import VCalendar from 'v-calendar'
import DatePicker from 'v-calendar/lib/components/date-picker.umd.min'

Vue.component('vc-date-picker', DatePicker)
